export default "__VITE_ASSET__BgscDwdk__"